<app-modal>
  <app-entity-flag-table [entityId]="data.entityId"
                         [campaignId]="data.campaignId"
                         (followUpCompleted)="close($event)"
                         ></app-entity-flag-table>
</app-modal>
